
    import { ref, defineComponent } from 'vue'
    import emailjs from 'emailjs-com';
    import { useToast } from "vue-toastification";
    import {
      TransitionRoot,
      TransitionChild,
      Dialog,
      DialogPanel,
      DialogTitle,
    }  from '@headlessui/vue'
    
    export default defineComponent({
      setup(){
       const isOpen = ref(false)
       return {
        isOpen
       }
      },
      components:{
          TransitionChild,
          TransitionRoot,
          Dialog,
          DialogPanel,
          DialogTitle
         },
         data(){
           return{
             name: '',
             email: '',
             message: '',
             toast:useToast()
           }
         },
      methods:{
        closeModal() {
      this.isOpen = false
    },
     openModal() {
      this.isOpen = true
    },
    sendEmail(){
      
     const templateParams = {
        from_name: this.name,
        from_email: this.email,
        to_name: 'Ian Mugenya',
        message: this.message,
     };
      try {
        emailjs.send(
          'service_ykmd805',
          'template_5qcid5q',
          templateParams,
          '3ldMW-PRkgwrasBTN'
      )
      this.toast.success('Message sent successfully')
      } catch (error) {
       this.toast.error('Unable to send message') 

      }
      this.closeModal()
      this.name = ''
      this.email = ''
      this.message = ''
      
    }
    }
    })
    
    